import { gql } from "@apollo/client";
const GET_ACCOUNTING_SYSTEM_INVOICES = gql`
  query GetAccountingSystemInvoices {
    getAccountingSystemInvoices {
      accountingSystemKey
      total
      items {
        externalInvoiceId
        externalInvoiceDocumentNumber
        externalInvoiceCustomerId
        externalInvoiceOpenBalance
        externalInvoiceDate
        deductionPurchaserKey
        deductionPurchaserName
      }
    }
  }
`;
export default GET_ACCOUNTING_SYSTEM_INVOICES;